module.exports = __webpack_public_path__ + "img/1535053970.684acfc6.jpg";